var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReturns(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_131_3604",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#1F1F1F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_131_3604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2998 17.3L3.6998 12.7C3.5998 12.6 3.52897 12.4917 3.4873 12.375C3.44564 12.2584 3.4248 12.1334 3.4248 12C3.4248 11.8667 3.44564 11.7417 3.4873 11.625C3.52897 11.5084 3.5998 11.4 3.6998 11.3L8.3248 6.67503C8.50814 6.4917 8.7373 6.4042 9.0123 6.41253C9.2873 6.42086 9.51647 6.5167 9.6998 6.70003C9.88314 6.88336 9.9748 7.1167 9.9748 7.40003C9.9748 7.68336 9.88314 7.9167 9.6998 8.10003L6.7998 11H18.9998V8.00003C18.9998 7.7167 19.0956 7.4792 19.2873 7.28753C19.479 7.09586 19.7165 7.00003 19.9998 7.00003C20.2831 7.00003 20.5206 7.09586 20.7123 7.28753C20.904 7.4792 20.9998 7.7167 20.9998 8.00003V12C20.9998 12.2834 20.904 12.5209 20.7123 12.7125C20.5206 12.9042 20.2831 13 19.9998 13H6.7998L9.7248 15.925C9.90814 16.1084 9.99564 16.3375 9.9873 16.6125C9.97897 16.8875 9.88314 17.1167 9.6998 17.3C9.51647 17.4834 9.28314 17.575 8.9998 17.575C8.71647 17.575 8.48314 17.4834 8.2998 17.3Z",
    fill: "#1F1F1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturns);
export default __webpack_public_path__ + "static/media/returns.d53d531908db4251dd005305f22ec96a.svg";
export { ForwardRef as ReactComponent };